/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Section_AdministrationInputs */

const en_settings_section_administration = /** @type {(inputs: Settings_Section_AdministrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration Settings`)
};

const de_settings_section_administration = /** @type {(inputs: Settings_Section_AdministrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrations-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Administration Settings" |
*
* @param {Settings_Section_AdministrationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_section_administration = /** @type {((inputs?: Settings_Section_AdministrationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Section_AdministrationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_section_administration(inputs)
	return de_settings_section_administration(inputs)
});